"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cameraEventSchema = exports.blogDefaultsSchema = exports.contactSettingsSchema = exports.analyticsSettingsSchema = exports.seoSettingsSchema = exports.fleetSettingsSchema = exports.favouritePoiSchema = exports.routingSettingsSchema = exports.ubiSettingsSchema = exports.walletSettingsSchema = exports.mapSettingsSchema = void 0;
__exportStar(require("./telemetry"), exports);
__exportStar(require("./events"), exports);
__exportStar(require("./devices"), exports);
__exportStar(require("./settings"), exports);
__exportStar(require("./blog"), exports);
var settings_1 = require("./settings");
Object.defineProperty(exports, "mapSettingsSchema", { enumerable: true, get: function () { return settings_1.mapSettingsSchema; } });
Object.defineProperty(exports, "walletSettingsSchema", { enumerable: true, get: function () { return settings_1.walletSettingsSchema; } });
Object.defineProperty(exports, "ubiSettingsSchema", { enumerable: true, get: function () { return settings_1.ubiSettingsSchema; } });
Object.defineProperty(exports, "routingSettingsSchema", { enumerable: true, get: function () { return settings_1.routingSettingsSchema; } });
Object.defineProperty(exports, "favouritePoiSchema", { enumerable: true, get: function () { return settings_1.favouritePoiSchema; } });
Object.defineProperty(exports, "fleetSettingsSchema", { enumerable: true, get: function () { return settings_1.fleetSettingsSchema; } });
Object.defineProperty(exports, "seoSettingsSchema", { enumerable: true, get: function () { return settings_1.seoSettingsSchema; } });
Object.defineProperty(exports, "analyticsSettingsSchema", { enumerable: true, get: function () { return settings_1.analyticsSettingsSchema; } });
Object.defineProperty(exports, "contactSettingsSchema", { enumerable: true, get: function () { return settings_1.contactSettingsSchema; } });
Object.defineProperty(exports, "blogDefaultsSchema", { enumerable: true, get: function () { return settings_1.blogDefaultsSchema; } });
var events_1 = require("./events");
Object.defineProperty(exports, "cameraEventSchema", { enumerable: true, get: function () { return events_1.cameraEventSchema; } });
__exportStar(require("./reports"), exports);
__exportStar(require("./vehicles"), exports);
__exportStar(require("./drivers"), exports);
__exportStar(require("./conversations"), exports);
__exportStar(require("./billing"), exports);
__exportStar(require("./agriculture-ops"), exports);
__exportStar(require("./insurance-ops"), exports);
__exportStar(require("./ubi"), exports);
__exportStar(require("./wallet"), exports);
__exportStar(require("./command"), exports);
__exportStar(require("./tickets"), exports);
__exportStar(require("./user-management"), exports);
__exportStar(require("./providers"), exports);
__exportStar(require("./notifications"), exports);
__exportStar(require("./tenant-access"), exports);
__exportStar(require("./marketing-images"), exports);
__exportStar(require("./commercial"), exports);
__exportStar(require("./agriculture-ops.data"), exports);
